<script>
import debounce from 'lodash/debounce';
import FaqVote from './faq-vote.vue';

export default {

    name: 'Faq',

    components: {
        FaqVote
    },

    data() {
        return {
            styleTag: null,
            search: '',
        }
    },

    created: function() {
        let head = document.head || document.getElementsByTagName('head')[0];

        this.styleTag = document.createElement('style');
        head.appendChild(this.styleTag);
    },

    methods: {
        doSearch(search) {
            if (!search) {
                this.styleTag.innerHTML = "";
            }
            else {
                this.styleTag.innerHTML = ".faq-accordion__item:not([data-index*=\"" + search.toLowerCase() + "\"]) { display: none; }";

                gtmGaEvent('Support', 'Search', search, search);
            }
        }
    },
}
</script>